// const backendUrl = 'http://localhost:7001';
const backendUrl = 'https://www.haloholidays.co.uk';

export const fetchHotelDetails = async (hotelId: string): Promise<any> => {
  const url = `${backendUrl}/api/hotel-details/${hotelId}`;
  return await fetchApi(url);
};

export const fetchTourDetails = async (tourQuery: string): Promise<any> => {
  const url = `${backendUrl}/api/tour-details/${tourQuery}`;
  return await fetchApi(url);
};

export const fetchSpecificTourDetail = async (slug: string): Promise<any> => {
  const url = `${backendUrl}/api/specific-tour-detail/${slug}`;
  return await fetchApi(url);
};

export const fetchHotelPrice = async (
  hotelId: string,
  arrivalDate: string,
  departureDate: string,
  adults: number,
  childrenAge: string,
  
): Promise<any> => {
  const url = `${backendUrl}/api/hotel-price?hotel_id=${hotelId}&arrival_date=${arrivalDate}&departure_date=${departureDate}&adults=${adults}&children_age=${childrenAge}`;
  return await fetchApi(url);
};

const fetchApi = async (url: string): Promise<any> => {
  const options = {
    method: 'GET',
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorData = await response.json();
      console.error(`API Error: ${errorData.message}`);
      throw new Error(errorData.message || 'Failed to fetch data');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(`Fetch API Error: ${error.message}`);
      throw error;
    } else {
      console.error('Fetch API Error: An unknown error occurred');
      throw new Error('An unknown error occurred');
    }
  }
};